const UploadHistoryBehaviorType = {
  Override: "Override",
  Add: "Add",
};

module.exports = Object.freeze(UploadHistoryBehaviorType);
